export default __webpack_public_path__ + "static/media/bicutan-map.f6cc0376.jpg";